module.exports = __webpack_public_path__ + "static/media/playbook-home-tiny.43c1f1c6.jpg";